// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {use_payment_methods} from './util.js';
import {Method_picker} from './method_picker.js';

export function Method_picker_connected({
    className,
    value,
    on_change,
    meta,
    render_item,
    extra_items,
    all_active,
})
{
    const list = use_payment_methods();
    return <Method_picker className={className} value={value}
      on_change={on_change} meta={meta} items={list} all_active={all_active}
      render_item={render_item} extra_items={extra_items}/>;
}
